import { system, Config } from "styled-system"

const configs: Config = {
	transition: {
		property: "transition"
	}
}

export const transition = system(configs)
